import React from 'react';
import PropTypes from 'prop-types';
import Table from 'cccisd-table';
import InfoTooltip from 'js/vendor/reports/components/InfoTooltip';
const ExclusionInfoTable = props => {
    const { data } = props;

    const filters = [
        {
            text: 'Invalid Full Meeting Attendance Subscale',
            tooltip: 'Invalid if 4 or more items from 1A-1F are N/A',
            key: 'invalidFMA',
        },
        {
            text: 'Invalid Based on Priority Needs Subscale',
            tooltip: 'Invalid if 4 or more items from 4A – 4E are N/A',
            key: 'invalidPN',
        },
        {
            text: 'Invalid Natural and Community Supports Subscale',
            tooltip: 'Invalid if 4 or more items from 5A-5E N/A',
            key: 'invalidNC',
        },
        {
            text: 'Invalid Outcomes-Based Process Subscale',
            tooltip: 'Invalid if 4 or more items from 6A-6E are N/A',
            key: 'invalidOB',
        },
        {
            text: 'Invalid TOM 2.0 Form',
            tooltip: 'Entire record invalid if 4 or more subscales are N/A.',
            key: 'invalid',
        },
    ];

    const getData = () => {
        let rows = [];
        let totals = {};
        for (var youth of data) {
            for (var filter of filters) {
                if (totals[filter.key]) {
                    totals[filter.key] += youth[filter.key];
                } else {
                    totals[filter.key] = youth[filter.key];
                }
            }
        }
        for (var row of filters) {
            rows.push({ filter: row, count: totals[row.key] });
        }
        return rows;
    };

    const cols = [
        {
            name: 'filter',
            label: 'Filter',
            render(value, row) {
                return (
                    <div style={{ display: 'flex' }}>
                        {value.text}
                        <InfoTooltip text={value.tooltip} />
                    </div>
                );
            },
        },
        { name: 'count', label: 'Count' },
    ];

    const tableData = getData();

    return <Table data={tableData} rowKey="filter" columns={cols} showPerPageOptions={false} isCsvDownload />;
};

ExclusionInfoTable.propTypes = {
    data: PropTypes.array,
};

export default ExclusionInfoTable;
